import useTiposIndiceMonetario from "core/features/shared/useTiposIndiceMonetario";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { useState } from "react";

export interface SelectTiposIndiceMonetarioProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectTiposIndiceMonetario({
  value,
  onChange,
  ...rest
}: SelectTiposIndiceMonetarioProps) {
  const [search, setSearch] = useState<string>();

  const { isLoading, data } = useTiposIndiceMonetario();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Índice de atualização monetária"
      value={value}
      allowClear={false}
      showSearch
      searchValue={search}
      onSearch={setSearch}
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectTiposIndiceMonetario;
